<template>
    <div class="secret">
        <input class="input" :name="name" :placeholder="placeholder" :readonly="readonly" :type="newShowSecret ? 'text' : 'password'" v-model="newValue" @blur="$emit('blur')" @focus="$emit('focus')"/>
        <button type="button" v-on:click="toggleShowSecret">{{ newShowSecret ? 'hide' : 'show' }}</button>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'password',
    mixins: [
        Default
    ],
    props: ['name', 'placeholder', 'showSecret', 'value', 'readonly'],
    data() {
        return {
            newValue: '',
            newShowSecret: false
        };
    },
    created() {
        this.newValue = this.value;
        this.newShowSecret = this.showSecret;
    },
    methods: {
        toggleShowSecret: function() {
            // If this is in readonly mode (like used in displaySecret.vue)
            // -then we don't want to show the secret
            // -instead the parent should listen for the toggleSecret event and set the model manually
            if (!this.readonly)
                this.newShowSecret = !this.newShowSecret;

            this.$emit('toggleSecret');
        }
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        },
        showSecret: function() {
            this.newShowSecret = this.$props.showSecret;
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/customInput/input";

    .secret {
        width: $width;
        @extend %input-with-button;
        button {
            right: .5em;
            top: .4em;
            padding: .25em 1em .25em 1em;
        }

        input {
            width: 100%;
            padding-right: 110px;

            &[readonly] {
                color: $secondary-color;
                cursor: default;
            }
        }
    }
</style>